import React from 'react';
import { Totals } from '../../../../tabs/GainLoss/Components/RealizedGainLossTab/components/Totals/Totals';

interface Props {
  title: string;
}

export const RealizedGainLossSummaryCard = ({ title }: Props) => {
  return <Totals title={title} />;
};
